import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { TTPDocumentRecordsResponse } from './types';

export function useTPDocumentRecords(companyId: number | null) {
  const baseUrl = `tp-document-record?companyId=${companyId}`;

  const {
    data,
    error,
    mutate,
  }: {
    data?: TTPDocumentRecordsResponse;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    companyId ? baseUrl : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
    isLoading: !data && !error,
  };
}
